module.exports = "/images/model_28ca7e.png";